module.exports = __webpack_public_path__ + "static/media/Rating.7142f48f.svg";